import styled from 'styled-components'
import Container from '../../components/atoms/Container'

export const LoadingCardContainer = styled(Container)`
  position: relative;
`
